<script setup lang="ts">
import type { CarouselI18nItem } from '~/types/elementsUi'
import type { FAIconName } from '#shared/types/generated-icons'

const { tm } = useI18n('components.templates.sections.our-impact-section')

interface ImpactCarousel extends CarouselI18nItem {
  icon: FAIconName
}

const impactItems = computed<ImpactCarousel[]>(() => {
  return tm('.items') as ImpactCarousel[]
})
</script>

<template>
  <VSection title=".title">
    <template #content>
      <VCarousel
        v-slot="{ item }"
        :items="impactItems"
        :number-of-items="{ mobile: 1, tablet: 2, desktop: 3, widescreen: 4 }"
        loop
        dots
        class="mt-4"
        sr-label=".carousel-aria-label"
      >
        <div class="flex flex-col items-center justify-center gap-4">
          <VIcon :icon="item.icon" class="mt-4 mb-2 h-12 w-12 text-6xl" />
          <h3 class="title mb-0! text-h4">
            {{ item.title }}
          </h3>
          <p class="text-center font-semibold">
            {{ item.description }}
          </p>
        </div>
      </VCarousel>
    </template>
  </VSection>
</template>

<style scoped></style>
